import styled, { css } from 'styled-components';
import isMobileApp from '@upgrade/ui-utils/utils/mobile-app/is-mobile-app';
import { mb } from '../Spacing/core';
import { generateResponsiveTemplate } from '../utils/styles-utils';
const headingSizeMap = {
  h1: 'xl',
  h2: 'lg',
  h3: 'md',
  h4: 'sm',
  h5: 'xs',
  h6: 'xxs'
};
const getSizing = ({
  viewport,
  size,
  heading,
  as,
  theme
}) => {
  const sizeValue = size || heading && headingSizeMap[as];
  if (!sizeValue) return '';
  return theme.typography.sizes[heading ? 'headings' : 'text'][viewport][sizeValue];
};
const getWeight = ({
  $weight,
  $bold
}) => {
  if ($bold || $weight === 'bold') {
    return '500';
  }
  if ($bold === false) {
    return '400';
  }
  return $weight;
};
const breakWordStyles = ({
  $breakWord,
  $lineBreak,
  $noWrap
}) => {
  // Mobileapp: 'overflow-wrap: break-word;' does not work as intended in webview
  if (isMobileApp() || $lineBreak) {
    return $breakWord || $lineBreak ? 'line-break: anywhere;' : undefined;
  }
  if ($noWrap) {
    return 'white-space: nowrap;';
  }
  return $breakWord != null ? `overflow-wrap: ${$breakWord ? 'break-word' : 'normal'};` : undefined;
};
const fontWeightStyles = ({
  $weight,
  $bold
}) => {
  const weight = getWeight({
    $weight,
    $bold
  });
  return weight != null ? `font-weight: ${weight};` : undefined;
};
const fontStyleStyles = ({
  $italic
}) => $italic != null ? `font-style: ${$italic ? 'italic' : 'normal'};` : undefined;
const dottedStyles = ({
  $dotted,
  theme
}) => $dotted ? `
        padding-bottom: 2px;

        border-bottom: none;
        background-image: linear-gradient(
          to right,
          ${theme.palette.semanticInfoStrong} 40%,
          ${theme.palette.semanticInfoStrong}00 20%
        );
        background-repeat: repeat-x;
        background-position: bottom;
        background-size: 5px 2px;
      ` : undefined;
const ellipsisStyles = ({
  $ellipsis
}) => $ellipsis ? `
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      ` : undefined;
export const responsiveFontSize = args => {
  let s;
  let h;
  if (typeof args === 'string') {
    s = args;
  } else if (typeof args === 'object') {
    ({
      s,
      h
    } = args);
  }
  return ({
    $size,
    $heading,
    as,
    theme
  }) => {
    const size = s || $size;
    const heading = h || $heading;
    // Dont output responsive styles for md or default Text size
    const outputResponsive = heading || !heading && size !== 'md' && size !== undefined;
    return css`
      ${getSizing({
      viewport: 'mobile',
      size,
      heading,
      as,
      theme
    })};

      ${outputResponsive ? css`
            @media (min-width: ${props => props.theme.mediaSm}) {
              ${getSizing({
      viewport: 'desktop',
      size,
      heading,
      as,
      theme
    })}
            }
          ` : ''}
    `;
  };
};
const ta = value => generateResponsiveTemplate(value, 'text-align');
export const StyledText = styled.span`
  ${responsiveFontSize()};

  ${breakWordStyles}
  ${fontWeightStyles}
  ${fontStyleStyles}
  ${({
  $align
}) => ta($align)}
  color: ${({
  $color,
  theme
}) => theme.palette[$color] || $color};
  text-transform: ${({
  $transform
}) => $transform};
  ${({
  $marginBottom
}) => mb($marginBottom)};
  ${dottedStyles};
  ${ellipsisStyles}
`;
//# sourceMappingURL=styles.js.map